import React, { useMemo } from 'react';

import { CustomerType, PerformanceDataV2, PerformanceOrderTypes } from 'apis/merchant-gateway/insights';

import { OrderType } from '../../types';
import VerticalBarChart from '../charts/VerticalBarChart';
import { ChartData, LegendChartType, Legends } from '../charts/types';

export type CustomerBaseChartProps = {
  legends: Legends<'total'> | Legends<CustomerType> | Legends<OrderType>;
  data: PerformanceDataV2<string, PerformanceOrderTypes>[];
  summaryKey: string;
};

const CustomerBaseChart = ({ legends, data, summaryKey }: CustomerBaseChartProps) => {
  const chartData: ChartData<Legends<CustomerType | OrderType>> = useMemo(
    () =>
      data.map(({ label, split, total }) => {
        const regularCustomersPart = split?.find(part => part.label === OrderType.Regular);
        const woltPlusCustomersPart = split?.find(part => part.label === OrderType.WoltPlus);
        const totalCustomers = total?.customersCount ?? 0;

        return {
          [CustomerType.NEW]: total?.firstTimeCustomersCount ?? 0,
          [CustomerType.RETURNING]: total?.returningCustomersCount ?? 0,
          [OrderType.Regular]: regularCustomersPart?.total?.customersCount ?? 0,
          [OrderType.WoltPlus]: woltPlusCustomersPart?.total?.customersCount ?? 0,
          total: totalCustomers,
          summaryValue: totalCustomers,
          name: label || '',
        };
      }),
    [data],
  );

  return (
    <VerticalBarChart
      legends={legends}
      axisIntegerOnly={{ [LegendChartType.BAR]: true }}
      data={chartData}
      summaryKey={summaryKey}
    />
  );
};

export default CustomerBaseChart;
